import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose-500/10 border border-rose-500/30 text-rose-300 text-xs font-semibold uppercase tracking-widest">
          Confidentialité
        </div>
        <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl">Politique de confidentialité</h1>
        <p className="mt-2 text-slate-500 text-sm">Conforme RGPD & Loi n° 2008-12 du Sénégal (CDP)</p>

        <div className="mt-10 space-y-8 text-slate-300 leading-relaxed">
          <section>
            <h2 className="font-display text-xl font-bold text-white">1. Responsable de traitement</h2>
            <p className="mt-2">JOTALY, opéré depuis Dakar, Sénégal — contact : <a href="mailto:contactjotaly@gmail.com" className="text-rose-400 hover:underline">contactjotaly@gmail.com</a>.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">2. Données collectées</h2>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Compte : nom, email, mot de passe hashé (bcrypt), ou identité Google via OAuth</li>
              <li>Activité : lives suivis, enchères placées, commandes, chat, avis</li>
              <li>Paiement : ID de transaction Wave/Orange Money (aucune donnée bancaire n'est stockée)</li>
              <li>Techniques : IP (rate-limit anti-spam), user-agent, cookies de session</li>
            </ul>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">3. Finalités</h2>
            <p className="mt-2">Fournir le service, authentifier les utilisateurs, prévenir la fraude, envoyer des notifications transactionnelles et newsletter (opt-in), améliorer la Plateforme.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">4. Base légale</h2>
            <p className="mt-2">Exécution du contrat (compte, enchères, paiement), consentement (newsletter), intérêt légitime (sécurité, prévention de la fraude).</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">5. Partage</h2>
            <p className="mt-2">Vos données ne sont jamais vendues. Elles sont partagées uniquement avec : (a) l'autre partie à la transaction (nom acheteur/vendeur pour la livraison), (b) nos sous-traitants techniques (Emergent — email Resend, hébergeur), (c) autorités si obligation légale.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">6. Durée de conservation</h2>
            <p className="mt-2">Compte : jusqu'à demande de suppression. Journaux d'audit admin : 12 mois. Logs de rate-limit : &lt; 24h. Newsletter : jusqu'à désabonnement.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">7. Vos droits</h2>
            <p className="mt-2">Vous pouvez à tout moment demander l'accès, la rectification, la suppression, la limitation ou la portabilité de vos données. Écrivez-nous à <a href="mailto:contactjotaly@gmail.com" className="text-rose-400 hover:underline">contactjotaly@gmail.com</a>. Vous pouvez également saisir la Commission de Protection des Données Personnelles (CDP) du Sénégal.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">8. Cookies</h2>
            <p className="mt-2">Nous utilisons uniquement des cookies techniques nécessaires (session_token httpOnly, préférence de langue). Aucun cookie de tracking publicitaire.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">9. Sécurité</h2>
            <p className="mt-2">Mots de passe hashés (bcrypt), tokens signés JWT HS256 avec secret aléatoire, cookies session httpOnly/secure/samesite, allowlist CORS stricte, rate-limiting, audit log admin.</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
